import React from 'react';
import '../../css/Testimonial.css';
import doloresImage from '../../images/dolores.png';

const Testimonial = () => {
    return (
        <div className="testimonial">
            <h2 className="testimonial-title">Testimonials</h2>
            <div className="testimonial-card">
                <div className="testimonial-content">
                    <img src={doloresImage} alt="Dolores" className="testimonial-image" />
                    <p className="testimonial-text">"Hello :) Second time around was great! It captured what I would have used but in a more efficient manner... done in seconds versus minutes :) and had a lot of detail for sure!"</p>
                    <p className="testimonial-author">- DOLORES, MSSW, LCSW</p>
                </div>
            </div>
        </div>
    );
};

export default Testimonial;
